// Scoped inside the guard on purpose: the cart page renders both the drawer and
// the cart section, so this file can be requested twice. Top-level consts would
// throw on the second execution.
if (!customElements.get('cart-discount-form')) {
  const CART_DISCOUNT_COOKIE = 'applied-discount-code';
  const CART_DISCOUNT_COOKIE_DAYS = 7;

  class CartDiscountForm extends HTMLElement {
    connectedCallback() {
      this.toggle = this.querySelector('[data-discount-toggle]');
      this.fields = this.querySelector('[data-discount-fields]');
      this.input = this.querySelector('[data-discount-input]');
      this.submit = this.querySelector('[data-discount-submit]');

      this.applied = this.querySelector('[data-discount-applied]');
      this.appliedCode = this.querySelector('[data-discount-applied-code]');
      this.change = this.querySelector('[data-discount-change]');

      this.toggle?.addEventListener('click', this.onToggle.bind(this));
      this.submit?.addEventListener('click', this.apply.bind(this));
      this.change?.addEventListener('click', this.onChange.bind(this));
      this.input?.addEventListener('keydown', event => {
        if (event.key !== 'Enter') return;
        // The field deliberately sits outside the checkout form, so Enter has
        // nothing to submit. Handle it here instead.
        event.preventDefault();
        this.apply();
      });

      this.showStoredCode();
    }

    /**
     * A held code is only ever in the cookie: Shopify keeps it for checkout
     * rather than putting it on the cart, so the total legitimately does not
     * move until then. Showing the code beats asking for another one.
     */
    showStoredCode() {
      const code = typeof getCookie === 'function' ? getCookie(CART_DISCOUNT_COOKIE) : null;
      if (!code || !this.applied || !this.appliedCode) return;

      // textContent, never innerHTML — this value comes from a cookie.
      this.appliedCode.textContent = code;
      this.applied.hidden = false;
      if (this.toggle) this.toggle.hidden = true;
    }

    onChange() {
      if (this.applied) this.applied.hidden = true;
      if (this.fields) this.fields.hidden = false;
      if (this.input) this.input.value = '';
      this.input?.focus();
    }

    onToggle() {
      const isOpen = this.toggle.getAttribute('aria-expanded') === 'true';
      this.toggle.setAttribute('aria-expanded', String(!isOpen));
      if (this.fields) this.fields.hidden = isOpen;
      if (!isOpen) this.input?.focus();
    }

    apply() {
      const code = (this.input?.value || '').trim();
      if (!code) {
        this.input?.focus();
        return;
      }

      // Remember the code the same way an emailed ?discount= link does, so the
      // announcement bar reports it once the page comes back.
      if (typeof setCookie === 'function') {
        setCookie(CART_DISCOUNT_COOKIE, code, CART_DISCOUNT_COOKIE_DAYS);
      }

      // The Ajax cart API cannot apply discount codes; Shopify's own discount
      // route is the only way to put one on the session.
      const root = this.dataset.rootUrl || '/';
      const base = root.endsWith('/') ? root : `${root}/`;
      const redirect = this.dataset.redirect || `${base}cart`;

      window.location.href = `${base}discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(redirect)}`;
    }
  }

  customElements.define('cart-discount-form', CartDiscountForm);
}
